import { useQuery } from '@tanstack/react-query'
import { Space, Tooltip, theme } from 'antd'
import { setAppSpinning } from 'app/appSlice'
import dayjs from 'dayjs'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import CustomDataTable from 'general/components/CustomDataTable'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import { IconAction } from 'general/components/GroupButton/styles'
import TableAction from 'general/components/GroupButton/TableAction'
import FindInvoiceModal from 'general/components/Modal/FindInvoiceModal'
import ModalUnauthorized from 'general/components/Modal/ModalUnauthorized'
import {
  INVOICE_TYPE_TO_QUERY,
  REPORT_TYPES,
  STATUS_ACCOUNTINGDOCUMENTS,
  TICKET_STATUS,
} from 'general/constants/AppConstants'
import SelectOptions from 'general/constants/SelectOptions'
import Utils from 'general/utils/Utils'
import useFilter from 'hooks/useFilter'
import useRouter from 'hooks/useRouter'
import useSearchDebounce from 'hooks/useSearchDebounce'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { queries } from './queries'
import './style.scss'
import InvoiceReportHelper from 'general/helpers/InvoiceReportHelper'
import invoiceReportApi from 'api/invoiceReportApi'
import InvoiceHelper from 'general/helpers/InvoiceHelper'
import ToastHelper from 'general/helpers/ToastHelper'
import invoiceApi from 'api/invoiceApi'
import SendReportModal from 'general/components/Modal/SendReportModal'
import SendInvoiceReportModal from 'general/components/Modal/SendInvoiceReportModal'
import FindDocumentModal from 'general/components/Modal/FindDocumentModal'
import { thunkExportFileDeductionDocuments } from 'features/TaxDeductionDocuments/taxDeductionDocumentsSlice'
import { saveAs } from 'file-saver'
import { thunkExportAccountingDocument } from 'features/AccountingDocument/accountDoucmentsSlice'
import { SpanNotYetReleasedTd } from 'features/TaxDeductionDocuments/styled'
function ListReplaceAccountingDocument() {
  // MARK --- Parmas: ---
  const { token } = theme.useToken()
  const [FindInvoiceModalShow, setFindDocumentModalShow] = useState(false)
  const [sendMailModalShow, setSendMailModalShow] = useState(false)
  const [rowSelected, setRowSelected] = useState(false)

  const dispatch = useDispatch()

  const [filters, setFilters] = useFilter(
    'replacedInvoiceList',
    'gFilterListReplacedInvoice',
  )
  const [showNoRight, setShowNoRight] = useState(false)
  const listFunction = useSelector((state) => state?.function?.listFunctions)
  const userFunction = useSelector((state) => state?.function?.userFunctions)
  const [isCreateReplacementInvoice] = useMemo(() => {
    return Utils.checkFunction(
      [
        {
          listFunctionCode: 'INVOICE_CREATE_REPLACEMENT_INVOICE',
        },
      ],
      userFunction,
      listFunction,
    )
  }, [userFunction, listFunction])

  const { navigate } = useRouter()
  const { debouncedSearch, search, setSearch } = useSearchDebounce('')
  const {
    data: listReplacedData,
    isLoading: gettingListData,
    isFetching,
  } = useQuery(queries.list(filters))

  const defaultValues = useMemo(() => {
    /** @type {FilterDefaultValueProp} */
    const arr = [
      {
        label: 'Trạng thái phát hành',
        alias: 'Trạng thái phát hành',
        formName: 'statusReleaseInvoiceReplace',
        options: SelectOptions.statusReleaseInvoiceReplace,
        value: SelectOptions.statusReleaseInvoiceReplace[0].value,
      },
      {
        label: 'Tình trạng gửi chứng từ',
        alias: 'Tình trạng gửi HĐ',
        formName: 'isSent',
        options: SelectOptions.isSent,
        value: SelectOptions.isSent[0].value,
      },
      {
        label: 'Trạng thái thông báo chứng từ sai sót',
        alias: 'Trạng thái TBHĐ sai sót',
        formName: 'errAnnouceIssueStatus',
        options: SelectOptions.errAnnouceIssueStatus,
        value: SelectOptions.errAnnouceIssueStatus[0].value,
        colSpan: 'FULL',
      },
    ]
    return arr
  }, [])

  const exportFile = async (
    typeFile,
    companyId,
    accounting_documentsId,
    view,
  ) => {
    const dataFile = await dispatch(
      thunkExportAccountingDocument({
        typeFile,
        companyId,
        accounting_documentsId,
      }),
    )
    if (dataFile?.payload?.data && dataFile.payload.fileName) {
      const { data, fileName } = dataFile.payload
      if (data.type === 'Buffer') {
        const byteArray = new Uint8Array(data.data)
        const blob = new Blob([byteArray], {
          type: typeFile == 'XML' ? 'application/xml' : 'application/pdf',
        })
        if (view) {
          const url = URL.createObjectURL(blob)
          window.open(url, '_blank')
        } else {
          saveAs(blob, fileName)
        }
      } else {
        ToastHelper.showError('Invalid buffer data')
      }
    }
  }

  const columns = [
    {
      name: <span className="red-header">CCCD/Hộ chiếu</span>,
      // sortable: false,
      // right: true,
      width: '150px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.replaceDocument?.employeeIdentification}
          </p>
        )
      },
    },
    {
      name: <span className="red-header">Họ và tên</span>,
      // sortable: false,
      // right: true,
      width: '150px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
            className="text-dark-75 font-weight-normal m-0 mr-4"
            title={row?.replaceDocument?.taxpayersName}
          >
            {row?.replaceDocument?.taxpayersName}
          </p>
        )
      },
    },
    {
      name: <span className="red-header">Mã số thuế</span>,
      // sortable: false,
      // right: true,
      width: '150px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.replaceDocument?.employeeTaxCode}
          </p>
        )
      },
    },
    {
      name: <span className="red-header">Số chứng từ</span>,
      // sortable: false,
      // right: true,
      width: '140px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.replaceDocument?.numberDocument}
          </p>
        )
      },
    },
    {
      name: <span className="red-header">Ký hiệu</span>,
      width: '110px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {`${row?.templatePaper?.symbolCode}/${row?.templatePaper?.symbolYear
              ?.toString()
              ?.substring(2)}${row?.templatePaper?.symbolType}`}
          </p>
        )
      },
    },
    {
      name: <span className="red-header">Ngày tạo</span>,
      // sortable: false,
      width: '120px',
      center: true,
      cell: (row) => {
        const date = dayjs(row?.replaceDocument?.createDate)
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {date.isValid() ? date.format('L') : ''}
          </p>
        )
      },
    },
    {
      name: <span className="text-primary">CCCD/Hộ chiếu</span>,
      // sortable: false,
      // right: true,
      width: '150px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.employeeIdentification}
          </p>
        )
      },
    },
    {
      name: <span className="text-primary">Họ và tên</span>,
      // sortable: false,
      // right: true,
      width: '150px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
            className="text-dark-75 font-weight-normal m-0 mr-4"
            title={row?.taxpayersName}
          >
            {row?.taxpayersName}
          </p>
        )
      },
    },
    {
      name: <span className="text-primary">Mã số thuế</span>,
      // sortable: false,
      // right: true,
      width: '150px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.employeeIdentification}
          </p>
        )
      },
    },
    {
      name: <span className="text-primary">Số chứng từ</span>,
      // sortable: false,
      // right: true,
      width: '140px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.numberDocument}
          </p>
        )
      },
    },
    {
      name: <span className="text-primary">Ký hiệu</span>,
      width: '110px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {`${row?.templatePaper?.symbolCode}/${row?.templatePaper?.symbolYear
              ?.toString()
              ?.substring(2)}${row?.templatePaper?.symbolType}`}
          </p>
        )
      },
    },
    {
      name: <span className="text-primary">Ngày tạo</span>,
      width: '120px',
      center: true,
      cell: (row) => {
        const date = dayjs(row?.createDate)
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {date.isValid() ? date.format('L') : ''}
          </p>
        )
      },
    },
    {
      name: <span className="text-primary">Ghi chú thay thế</span>,
      width: '430px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
            title={row?.noteType}
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '430px', // hoặc giá trị phù hợp
            }}
          >
            {row?.replaceDocument?.noteType}
          </p>
        )
      },
    },
    {
      name: <span className="text-primary">Trạng thái</span>,
      width: '200px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            <SpanNotYetReleasedTd
              color={
                row?.status == 1
                  ? '#019160'
                  : row?.status == 2
                    ? '#e61d1d'
                    : '#000000'
              }
              backGroundColor={
                row?.status == 1
                  ? '#ebfef7'
                  : row?.status == 2
                    ? '#ffcdcd'
                    : '#f1f3f5'
              }
            >
              {row?.status == 1
                ? 'Đã phát hành'
                : row?.status == 2
                  ? 'Ngừng phát hành'
                  : 'Chưa phát hành'}
            </SpanNotYetReleasedTd>
          </p>
        )
      },
    },
    {
      name: '',
      minWidth: '100px',
      center: true,
      compact: true,
      cell: (row) => {
        return (
          <Space align="left" className="w-100 px-5">
            {row?.replaceDocument?.accounting_documentsId && (
              <TableAction
                icon={
                  <IconAction
                    className="fa-light fa-eye"
                    style={{
                      color: token.colorError,
                    }}
                  />
                }
                titleActionText="Xem chứng từ bị thay thế"
                onClick={() => {
                  exportFile(
                    'PDF',
                    row?.companyId,
                    row?.replaceDocument?.accounting_documentsId,
                    1,
                  )
                }}
              />
            )}
            {row?.accounting_documentsId && (
              <TableAction
                titleActionText="Xem chứng từ thay thế"
                icon={
                  <IconAction
                    className="fa-light fa-eye"
                    style={{
                      color: token.colorPrimary,
                    }}
                  />
                }
                onClick={() => {
                  exportFile(
                    'PDF',
                    row?.companyId,
                    row?.accounting_documentsId,
                    1,
                  )
                }}
              />
            )}
            {row?.report && (
              <TableAction
                titleActionText="Gửi biên bản điện tử"
                icon={<IconAction className="fa-light fa-envelope" />}
                onClick={() => {
                  setRowSelected(row)
                  setSendMailModalShow(true)
                }}
              />
            )}
          </Space>
        )
      },
    },
  ]

  // MARK --- Effect: ---

  useEffect(() => {
    setFilters({
      page: 1,
      q: debouncedSearch,
    })
  }, [debouncedSearch, setFilters])

  useEffect(() => {
    const startColumnFirstHeader = 1
    const startColumnSecondHeader = 6
    const columnsSpanFirstHeader = 6
    const columnsSpanSecondHeader = 14
    const addHeaderTable = () => {
      const firstDivToRemove = document.querySelector('div.table-red-header')
      const secondDivToRemove = document.querySelector(
        'div.table-header-normal',
      )

      if (firstDivToRemove) {
        firstDivToRemove.remove()
      }
      if (secondDivToRemove) {
        secondDivToRemove.remove()
      }
      let firstHeaderWidth = 0
      let secondHeaderWidth = 0

      for (let i = startColumnFirstHeader; i <= columnsSpanFirstHeader; i++) {
        const div = document.querySelector(`div[data-column-id="${i}"]`)
        if (div) {
          firstHeaderWidth += div.getBoundingClientRect().width
        }
      }
      for (let i = startColumnSecondHeader; i <= columnsSpanSecondHeader; i++) {
        const div = document.querySelector(`div[data-column-id="${i}"]`)
        if (div) {
          secondHeaderWidth += div.getBoundingClientRect().width
        }
      }
      const rowDiv = document.querySelector('div[role="rowgroup"]')
      if (rowDiv) {
        const hasRowGroup =
          rowDiv.parentNode.querySelector('#rowGroupContainer')
        let containerDiv
        if (!hasRowGroup) {
          containerDiv = document.createElement('div')
          containerDiv.classList.add('d-flex')
          containerDiv.id = 'rowGroupContainer'
        } else
          containerDiv = rowDiv.parentNode.querySelector('#rowGroupContainer')
        const firstHeaderDiv = document.createElement('div')
        firstHeaderDiv.classList.add('table-red-header')
        firstHeaderDiv.style.width = `${Math.floor(firstHeaderWidth)}px`
        const spanElementFirstHeader = document.createElement('span')
        spanElementFirstHeader.textContent = 'Chứng từ bị thay thế'
        firstHeaderDiv.appendChild(spanElementFirstHeader)

        const secondHeaderDiv = document.createElement('div')
        secondHeaderDiv.classList.add('table-header-normal')
        secondHeaderDiv.style.width = `${Math.ceil(secondHeaderWidth)}px`
        const spanElementSecondHeader = document.createElement('span')
        spanElementSecondHeader.textContent = 'Chứng từ thay thế'
        secondHeaderDiv.appendChild(spanElementSecondHeader)

        containerDiv.appendChild(firstHeaderDiv)
        containerDiv.appendChild(secondHeaderDiv)
        // Insert the newDiv before the rowDiv
        rowDiv.parentNode.insertBefore(containerDiv, rowDiv)
      }
    }
    !gettingListData && addHeaderTable()
  }, [gettingListData])

  const navigateHandler = (row, classify) => {
    switch (classify) {
      case 'PXK':
        return navigate(
          `/hoa-don-dau-ra/xu-ly-hoa-don/phieu-xuat-kho/thay-the/${row?.invoiceId}`,
        )
      case 'MTT':
        return navigate(
          `/hoa-don-dau-ra/xu-ly-hoa-don/may-tinh-tien/thay-the/${row?.invoiceId}`,
        )
      default:
        return navigate(
          `/hoa-don-dau-ra/xu-ly-hoa-don/thay-the/${row?.invoiceId}`,
        )
    }
  }

  return (
    <ContentContainer wrapperClassName="list-replaced-invoice">
      <ContentContainer.Header
        titleContent={'Bảng kê chứng từ đã thay thế'}
        toolBar={
          <Space>
            <CustomAntButton
              text="Lập chứng từ thay thế"
              iconCn="fa-regular fa-plus"
              antProps={{
                type: 'primary',
                onClick: () => {
                  if (isCreateReplacementInvoice) setFindDocumentModalShow(true)
                  if (!isCreateReplacementInvoice) setShowNoRight(true)
                },
              }}
            />
          </Space>
        }
      >
        <Space>
          <CustomAntInput
            borderRadius="sm"
            type="search"
            loading={isFetching}
            inputProps={{
              value: search,
              onChange: (e) => setSearch(e.target.value),
            }}
          />
          {/* <FilterPopover
            defaultValues={defaultValues}
            onApply={setFilters}
            savedKey="gFilterListReplacedInvoice"
          /> */}
        </Space>
      </ContentContainer.Header>
      <ContentContainer.Body>
        <CustomDataTable
          wrapperClassName="table-replaced-invoice"
          columns={columns}
          dataSource={listReplacedData?.rows}
          isLoading={gettingListData}
          pagination={{
            currentPage: filters?.page,
            rowsPerPage: filters?.limit,
            total: listReplacedData?.total,
            onChangePage: (newPage) => {
              setFilters({
                page: parseInt(newPage),
              })
            },
            onChangeRowsPerPage: (newPerPage) => {
              setFilters({
                limit: parseInt(newPerPage),
                page: 1,
              })
            },
          }}
        />
      </ContentContainer.Body>

      <FindDocumentModal
        show={FindInvoiceModalShow}
        onHide={() => setFindDocumentModalShow(false)}
        title="Chọn chứng từ thay thế"
        checkBoxShow={false}
        selectableRows={true}
        showTab={true}
        status={STATUS_ACCOUNTINGDOCUMENTS.AUTHORITY_CODE_GIVEN}
        typeAd={'replace'}
        onSave={(data) => {
          setFindDocumentModalShow(false)
          navigate(
            `/hoa-don-dau-ra/chung-tu-tncn/thiet-lap/chungtu/lap-chung-tu?accounting_documents=${data?.accounting_documentsId}&type=copy&statusDocument=replace`,
          )
        }}
      />

      <ModalUnauthorized show={showNoRight} setShow={setShowNoRight} />
      <SendInvoiceReportModal
        reportType={TICKET_STATUS.REPLACE}
        invoice={rowSelected}
        show={sendMailModalShow}
        onHide={() => setSendMailModalShow(false)}
      />
    </ContentContainer>
  )
}

export default ListReplaceAccountingDocument
